import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

interface PageContainerProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  backgroundColor?: string;
}

/**
 * PageContainer - A reusable page wrapper with the theme background
 * Use this component to wrap page content for consistent styling across the app
 * Automatically uses theme colors when no backgroundColor is provided
 */
export default function PageContainer({
  children,
  style,
  backgroundColor,
}: PageContainerProps) {
  const { colors } = useTheme();
  const bgColor = backgroundColor ?? colors.background;

  return (
    <View style={[styles.container, { backgroundColor: bgColor }, style]}>
      <View style={styles.content} role="main">
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
  },
  content: {
    flex: 1,
    zIndex: 1,
  },
});
